export const produtos = [
  // ——— FARDAMENTOS (ids 1–9) ———
  {
    id: '1',
    titulo: 'Camisa Preta',
    categoria: 'Fardamentos',
    descricao: "Tamanhos Acima de XG o valor fica R$ 38,00",
    imagens: ['/img/camisa_preta.png'],
    tamanhos: ['P', 'M', 'G', 'GG', 'XG', 'XXG', 'XXXG'],
    preco: '40,00',
  },
  {
    id: '2',
    titulo: 'Moletom Preto',
    categoria: 'Fardamentos',
    imagens: ['/img/moletom_preto.png'],
    tamanhos: ['P', 'M', 'G', 'GG'],
    preco: '80,00',
  },
  {
    id: '3',
    titulo: 'Camisa Polo Feminina Preta',
    categoria: 'Fardamentos',
    imagens: ['/img/camisa_polo_feminina.png'],
    tamanhos: ['P', 'M', 'G', 'GG', 'XG', 'XXG', 'XXXG'],
    preco: '69,90',
  },
  {
    id: '4',
    titulo: 'Camisa Polo Masculino Preta',
    categoria: 'Fardamentos',
    imagens: ['/img/camisa_polo_masculina.png'],
    tamanhos: ['P', 'M', 'G', 'GG', 'XG', 'XXG', 'XXXG'],
    preco: '69,90',
  },
  {
    id: '5',
    titulo: 'Camisa Social Masculina',
    categoria: 'Fardamentos',
    descricao: "Preço Original R$ 90,00",
    imagens: ['/img/camisa_social_branca_masculina.png'],
    tamanhos: ['P', 'M', 'G', 'GG', 'XG', 'XXG', 'XXXG'],
    preco: '68,90',
  },
  {
    id: '6',
    titulo: 'Camisa Social Feminina',
    categoria: 'Fardamentos',
    descricao: "Preço Original R$ 89,90",
    imagens: ['/img/camisa_social_feminina.png'],
    tamanhos: ['P', 'M', 'G', 'GG', 'XG', 'XXG', 'XXXG'],
    preco: '68,90',
  },
  {
    id: '7',
    titulo: 'Camisa Polo Branca Masculino',
    categoria: 'Fardamentos',
    imagens: ['/img/camisa_polo_branca.png'],
    tamanhos: ['P', 'M', 'G', 'GG', 'XG', 'XXG', 'XXXG'],
    preco: '69,90',
  },
  {
    id: '8',
    titulo: 'Camisa Polo Branca Feminina',
    categoria: 'Fardamentos',
    imagens: ['/img/camisa_polo_feminia.png'],
    tamanhos: ['P', 'M', 'G', 'GG', 'XG', 'XXG', 'XXXG'],
    preco: '69,90',
  },
  {
    id: '9',
    titulo: 'Camisa Branca',
    categoria: 'Fardamentos',
    descricao: "Tamanhos Acima de XG o valor fica R$ 38,00",
    imagens: ['/img/camisa_branca.png'],
    tamanhos: ['P', 'M', 'G', 'GG', 'XG', 'XXG', 'XXXG'],
    preco: '35,00',
  },
  {
    id: '24',
    titulo: 'Calça Jeans - MCM',
    categoria: 'Fardamentos',
    imagens: ['/img/calca_mcm.png'],
    tamanhos: ['36', '38', '40', '42', '44', '46', '48', '50', '52', '54'],
    preco: '75,00',
  },

  // ——— ACESSÓRIOS (ids 10–23) ———
  {
    id: '10',
    titulo: 'Copo térmico 630ml',
    categoria: 'Acessorios',
    descricao: "Copo térmico em aço inox com parede dupla isolada a vácuo. A tampa inclui um abridor de garrafas. Ideal para preservar as suas bebidas frias ou quentes. Capacidade até 630mL.",
    dimensao: "097 X 171mm",
    imagens: ['/img/copoTermico.png'],
    tamanhos: [],
    preco: '35,90',
  },
  {
    id: '11',
    titulo: 'Copo térmico 400ml',
    categoria: 'Acessorios',
    imagens: ['/img/copo_termico_400.png'],
    descricao: "Copo em aço inox com corpo duplo isolado a vácuo e tampa deslizante (térmico). Capacidade até 400 mL. Preserva as bebidas quentes por 6h e frias por 12h. ",
    dimensao: "88x112mm",
    tamanhos: [],
    preco: '34,90',
  },
  {
    id: '12',
    titulo: 'Garrafa térmica inox',
    categoria: 'Acessorios',
    imagens: ['/img/garrafa_termica.png'],
    descricao: "Squeeze em aço inox com parede dupla e tampa com sistema de vácuo (térmico). Capacidade de até 510mL. Preserva as bebidas quentes por 8h e frias por 24h.",
    dimensao: "067 x 255mm",
    tamanhos: [],
    preco: '56,90',
  },
  {
    id: '13',
    titulo: 'Bolsa esportiva executiva',
    categoria: 'Acessorios',
    imagens: ['/img/bolsa_grande1.png'],
    descricao: "Bolsa esportiva executiva em 840D jacquard e 300D e interior forrado. Contém bolsos frontais, fundo com placa semi-rígida e alça de ombro ajustável com reforço almofadado.",
    dimensao: "520 x 300 x 220mm",
    tamanhos: [],
    preco: '59,90',
  },
  {
    id: '14',
    titulo: 'Bolsa térmica',
    categoria: 'Acessorios',
    imagens: ['/img/marmita1.png'],
    descricao: "Bolsa Térmica em non-woven (80 g/m²) com capacidade até 3L.",
    dimensao: "180 x 140 x 1300mm",
    tamanhos: [],
    preco: '49,90',
  },
  
  // {
  //   id: '15',
  //   titulo: 'Bolsa multiuso PVC',
  //   categoria: 'Acessorios',
  //   imagens: ['/img/bolsinha.png'],
  //   tamanhos: [],
  //   preco: '17,00',
  // },
  // {
  //   id: '16',
  //   titulo: 'Bolsa térmica',
  //   categoria: 'Acessorios',
  //   imagens: ['/img/MALA-DE-MÃO-f2.png'],
  //   tamanhos: [],
  //   preco: '49,90',
  // },
  // {
  //   id: '17',
  //   titulo: 'Bolsa térmica',
  //   categoria: 'Acessorios',
  //   imagens: ['/img/bolsa-termica2.png'],
  //   tamanhos: [],
  //   preco: '19,90',
  // },
  // {
  //   id: '18',
  //   titulo: 'Necessaire',
  //   categoria: 'Acessorios',
  //   imagens: ['/img/necessaire3.png'],
  //   tamanhos: [],
  //   preco: '64,90',
  // },
  {
    id: '19',
    titulo: 'Necessaire',
    categoria: 'Acessorios',
    imagens: ['/img/necessaire1.png'],
    descricao: "Necessaire em 600D com pega e bolso frontal.",
    dimensao: "200 x 115 x 85mm",
    tamanhos: [],
    preco: '23,90',
  },
  // {
  //   id: '20',
  //   titulo: 'Bateria portátil em ABS',
  //   categoria: 'Acessorios',
  //   imagens: ['/img/Bateria-portátil-em-ABS.png'],
  //   tamanhos: [],
  //   preco: '100,00',
  // },
  {
    id: '21',
    titulo: 'Caneca cerâmica',
    categoria: 'Acessorios',
    imagens: ['/img/CANECA-SOU-MCM.png'],
    descricao: "Caneca branca de cerâmica - 325ml",
    tamanhos: [],
    personalizavel: true,
    preco: '19,90',
  },
  {
    id: '22',
    titulo: 'Boné preto',
    categoria: 'Acessorios',
    descricao: "Boné Brim Preto",
    imagens: ['/img/bone_preto.png'],
    tamanhos: [],
    preco: '25,50',
  },
  // {
  //   id: '23',
  //   titulo: 'Cabo retrátil 5 em 1',
  //   categoria: 'Acessorios',
  //   imagens: ['/img/cabo-retratil.png'],
  //   tamanhos: [],
  //   preco: '42,90',
  // },
];
